// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../public/scss/style.scss
// module id = 720
// module chunks = 0